<template>
  <div>
    <div>
      <div class="VueCarousel-slide active" ref="story1">
        <div class="padding">
          <div>
            <p>I woke in the night with my sheets soaked in sweat, the taste of salt in my mouth and I was afraid. My mind raced and I listened for a sound I expected to hear, that I always hear. </p>
            <p> &nbsp;</p>
            <br>
<p>I could not hear him breathing, and it frightened me. I heard the rain outside the window, hammering on the glass and I could hear someone crying from across the hall outside the apartment, crying in the room the girl with bird arms lived in. </p>
            <p> &nbsp;</p>
            <br>
<p>Then he coughed and I let out the breath I did not know I had been holding since I woke. It rushed out of me like a scream. </p>
            <br>
<p>He coughed, and coughed some more, and then was suddenly silent. I wiped my face with the flannel by my side of the bed and threw back the covers. The room was dark and I walked across the floor and into the hallway. His room was unlit too, and I snapped the light switch on. </p>
            <p></p>
           <br>
 <p>There was nothing in the room. Nothing but a wooden crate and a pile of books. I screamed.</p>
            <p> &nbsp;</p>
           <br>
 <p>And then I blinked, and the heaped clothing became a body and the books a head and the crates a bed. And my child is there sleeping.
            My child was sleeping but for a moment was gone.</p>
            <p> &nbsp;</p>
            <br>
<p>He came back though, he returned to me.</p>
            <p> &nbsp;</p>
           <br>
 <p>Did he go to you, reach out to you?</p>
            <p> &nbsp;</p>
           <br>
 <p>would you even recognise him?</p>
            <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p> &nbsp;</p>
          </div>
        </div>
      </div>
      <div class="VueCarousel-slide hidden" ref="story2">
        <div class="padding">
          <div>
            <span class="arch">
              <p>I look out across the streets and the skyline and I see the footsteps I left behind as I walked to this spot. I see a moment that is coming fast, that is advancing like a storm from the sea, churning the sky and the harbour from horizon to here. The city in which I stand, which is old and built from stone and brick and memory, it can't hold, I see it now, it is too fluid, and it will wash away.</p>
              <p> &nbsp;</p>
              <p>When I close my eyes I see a coming storm.</p>
              <br>
              <p>I see another architecture impact upon this one, buildings crashing into each other and stone raining down into the street. A dustcloud gathering from the river, an impossible moment that gathers everything into it, the people below, their cries and their tears.</p>
             <br>
              <p>This is a dust made of memory and it leaves nothing behind.</p>
              <p>Then silence falls. </p>
              <br>
              <p>The city that is left is iron clad and garlanded in rust and dead roses. Creeping skyward, framing the stars and the firestorm behind the walls.
              Then the storm starts again, a flare between the flames and the water, a fire from heaven that licks at the plustens, the concrete and the wood, burning something vital away.
              Paint and oil, wax and linen.</p>
              <br>
<p>The streets are cleared, and only the remains of the city are visible. </p>
              <br>
<p>There were gardens here once. Flowers climbed the walls and grew around the railings.</p>
              <br>
<p>In the future I see there is nothing but burning and an echo, </p>
<p>clearing the ground. </p>
              <br>
<p>Behind me, I hear a voice, a child's voice asking a question. </p>
<p>Imploring an answer.  </p>
              <p></p>
              <p></p>
              <p> &nbsp;</p>
              <br>
              <p>I snap back, </p>
             <br>
 <p>I no longer see what will be, just what is. </p>
             <br>
 <p>There is no child, but there was. </p>
              <br>
<p>There were two cities </p>
<p>and there will be one. </p>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: '1',

  data () {
    return {
      title: 'Empty'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
